import { QueryClient } from '@tanstack/react-query';

/**
 * Instancia unica de QueryClient para toda la aplicacion.
 * Exportado como singleton para poder importarlo tanto en el provider de la app
 * como en el logout (limpieza de cache al cambiar de usuario).
 */
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1
        },
        mutations: {
            retry: 0
        }
    }
});

export default queryClient;
